export default __webpack_public_path__ + "static/media/image-48.7a2fcfd6.png";